module.exports = __webpack_public_path__ + "static/media/cert_116.f84c1f4d.jpg";